<template>
  <div class="base-container bg-default">
    <div class="white header">
      <v-container>
        <v-row justify="center">
          <v-img src="@/assets/img-finalizado.png" max-width="160" />
          <v-col cols="12">
            <h4 class="secondary-font text-center">Obrigado por preencher!</h4>
            <p class="text-center text--secondary secondary-font mt-1">Seu agendamento está confirmado.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-row no-gutters justify="center" class="content">
      <v-col cols="11" sm="7" md="5">
        <v-card rounded="xl" elevation="3" class="mb-4">
          <v-card-title class="pb-1">
            <v-chip :color="agendamento.online ? '#E3F0FF' : '#E3F5E9'" class="primary--text font-weight-bold">
              <v-icon left size="16">{{ agendamento.online ? 'mdi-account-voice' : 'mdi-hospital-building' }}</v-icon>
              {{ agendamento.online ? 'Teleatendimento' : 'Presencial' }}
            </v-chip>
          </v-card-title>
          <v-card-text>
            <p v-if="agendamento.online && agendamento.medico">
              <v-icon class="mr-1" size="20" color="primary">mdi-doctor</v-icon>
              <strong>Médico:</strong> {{ agendamento.medico }}
            </p>
            <template v-if="agendamento.online">
              <p>
                <v-icon class="mr-1" size="20" color="primary">mdi-calendar</v-icon>
                <strong>Data:</strong> {{ agendamento.dtHorarioMedico }}
              </p>
              <p>
                <v-icon class="mr-1" size="20" color="primary">mdi-clock-outline</v-icon>
                <strong>Horário:</strong> {{ horarioMedicoFormatado }} (Horário Local)
              </p>
            </template>
            <template v-else>
              <p>
                <v-icon class="mr-1" size="20" color="primary">mdi-calendar</v-icon>
                <strong>Data:</strong> {{ agendamento.dtAgendamento }}
              </p>
              <p v-if="agendamento.horario">
                <v-icon class="mr-1" size="20" color="primary">mdi-clock-outline</v-icon>
                <strong>Horário:</strong> {{ agendamento.horario }}
              </p>
              <p v-if="agendamento.nomeClinica">
                <v-icon class="mr-1" size="20" color="primary">mdi-hospital-building</v-icon>
                <strong>Local:</strong> {{ agendamento.nomeClinica }}
              </p>
              <p v-if="agendamento.endereco">
                <v-icon class="mr-1" size="20" color="primary">mdi-map-marker</v-icon>
                {{ agendamento.endereco }}
              </p>
            </template>
          </v-card-text>
        </v-card>

        <v-card rounded="xl" elevation="3" class="mb-6">
          <v-card-title class="pb-1">
            <v-icon left color="primary">mdi-information-outline</v-icon>
            <span class="secondary-font">Orientações</span>
          </v-card-title>
          <v-card-text>
            <p v-if="agendamento.online" class="secondary-font">
              Você será atendido de forma online. O link de acesso estará disponível {{ minutosAntesAtendimento }} minutos antes do horário agendado.
            </p>
            <p v-else class="secondary-font">
              Compareça ao local indicado no dia e horário agendados com documento de identificação com foto.
            </p>
            <div v-if="agendamento.online && agendamento.datetimeHorarioMedico" class="text-center mt-4">
              <AgendamentoCardButton
                :dtHorarioMedico="agendamento.dtHorarioMedico"
                :horarioMedico="horarioMedicoFormatado"
                :idAsoMeetingRoom="agendamento.idAsoMeetingRoom"
                :statusAsoMeetingRoom="agendamento.statusAsoMeetingRoom"
                :datetimeHorarioMedico="agendamento.datetimeHorarioMedico"
                :idAso="agendamento.idAso"
              />
            </div>
          </v-card-text>
        </v-card>

        <v-row no-gutters justify="center" class="mb-8">
          <v-btn
            @click="onFinalizar"
            color="warning"
            class="secondary-font text-capitalize font-weight-black"
            outlined
            rounded
          >
            Meus Agendamentos
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { subHours, format, isValid } from 'date-fns'
import AgendamentoCardButton from '@/modules/Agendamento/AgendamentoCardButton'

export default {
  components: {
    AgendamentoCardButton
  },
  data() {
    return {
      minutosAntesAtendimento: 5
    }
  },
  computed: {
    ...mapState('fichaClinica', ['agendamento']),
    horarioMedicoFormatado() {
      const horarioMedico = this.agendamento.horarioMedico
      if (!horarioMedico) return ''
      const partes = horarioMedico.split(' às ')
      if (partes.length === 2) {
        const inicio = this.formatHorarioLocal(partes[0].trim())
        const fim = this.formatHorarioLocal(partes[1].trim())
        return `${inicio} às ${fim}`
      }
      return this.formatHorarioLocal(horarioMedico)
    }
  },
  methods: {
    formatHorarioLocal(timeString) {
      const date = new Date(`1970-01-01T${timeString}:00Z`)
      if (!isValid(date)) return timeString
      const result = date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      if (result && result !== 'Invalid Date') return result
      const brt = subHours(date, 3)
      return format(brt, 'HH:mm')
    },
    onFinalizar() {
      this.$store.commit('fichaClinica/RESET')
      this.$router.push({ name: 'agendamentos' })
    }
  }
}
</script>

<style scoped>
.header {
  padding-bottom: 40px;
}
.content {
  margin-top: 24px;
}
</style>
